import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./DropDownSport.scss"; // Ensure SCSS has styles

const sportIcons = {
  badminton: "🏸",
  pickleball: "🏓",
  tennis: "🎾",
  football: "⚽",
};

const DropDownSport = ({ options, selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown">
      <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
        <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
        <ChevronDown size={18} />
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          {options.map((option) => (
            <li key={option} onClick={() => handleSelect(option)}>
              {sportIcons[option] || "❓"}{" "}
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropDownSport;
